import type { ColumnState } from 'ag-grid-community';

/**
 * Column event sources that mean a person changed the columns. Everything else
 * (the grid sizing itself, a reset, restoring a saved layout through the API)
 * must not be saved as the user's layout, or a copy of today's defaults would
 * stick to the user and hide later default changes from them.
 */
const USER_COLUMN_EVENT_SOURCES = new Set([
  'uiColumnMoved',
  'uiColumnResized',
  'uiColumnDragged',
  'uiColumnSorted',
  'toolPanelUi',
  'toolPanelDragAndDrop',
  'columnMenu',
  'contextMenu',
]);

export function isUserColumnEvent(event: { source?: string } | null | undefined): boolean {
  return typeof event?.source === 'string' && USER_COLUMN_EVENT_SOURCES.has(event.source);
}

/**
 * The saved entries for columns the grid still has, in saved order. A column
 * that was renamed or removed since the layout was saved is dropped, so an old
 * layout can never hide or reorder columns it does not know about.
 */
export function filterColumnState(
  state: readonly ColumnState[] | null | undefined,
  colIds: Iterable<string>,
): ColumnState[] {
  if (!Array.isArray(state)) return [];
  const known = new Set(colIds);
  return state.filter((col) => col && typeof col.colId === 'string' && known.has(col.colId));
}
